import Notices from "./Notices";
import AjaxBlocking from "./AjaxBlocking";
import $ from "jquery";

export default class Checkout {
	constructor() {
		this.jsCheckoutForm = document.querySelector(".jsCheckoutForm");
		this.jsCheckoutTitle = document.querySelector(".jsCheckoutTitle");
		this.jsCheckoutFirstPart = document.querySelector(".jsCheckoutFirstPart");
		this.jsCheckoutSecondPart = document.querySelector(".jsCheckoutSecondPart");
		this.jsCheckoutSecondPartContent = document.querySelector(".jsCheckoutSecondPartContent");
		this.jsCheckoutSecondCustomOrderReviewButtons = document.querySelector(".jsCheckoutSecondCustomOrderReviewButtons");
		this.jsCustomValidateCheckout = document.querySelectorAll(".jsCustomValidateCheckout");
		this.jsBillingPersonType = document.querySelectorAll("input[name='billing_person_type']");
		this.jsCheckAll = document.querySelector(".jsCheckAll");
		this.jsTerms = document.querySelectorAll(".jsTerms");
		this.fields = document.querySelectorAll(".form-row input, .form-row select");
		this.shippingMethodDescription = "";

		this.notices = new Notices();

		if (this.jsCheckoutForm) {
			this.validateCheckout();
		}
		this.events();
	}

	events() {
		if (this.jsCustomValidateCheckout) {
			this.jsCustomValidateCheckout.forEach((btn) => {
				btn.addEventListener("click", this.verifyNextStep.bind(this));
			});
		}

		if (this.jsBillingPersonType) {
			this.jsBillingPersonType.forEach((checkbox) => {
				checkbox.addEventListener("click", this.validateCheckout.bind(this));
			});
		}

		if (this.jsCheckAll) {
			this.jsCheckAll.addEventListener("change", this.checkAllTerms.bind(this));
		}

		$(document.body).on("updated_checkout", () => {
			const jsShippingMethodDescriptions = [...document.querySelectorAll(".jsShippingMethodDescription")];

			if (this.shippingMethodDescription === "") {
				this.shippingMethodDescription = document.querySelector(".jsShippingMethodDescription").value;
			}

			jsShippingMethodDescriptions.forEach((shippingMethodDescription) => {
				shippingMethodDescription.value = "";
			});
		});

		if (this.jsTerms) {
			this.jsTerms.forEach((checkbox) => {
				checkbox.addEventListener("change", this.checkTerm.bind(this));
			});
		}

		document.body.addEventListener("click", (e) => {
			if (e.target.classList.contains("jsCheckoutSummaryBack")) {
				e.preventDefault();
				this.changeToFirstStep(e.target.dataset.location);
			} else if (e.target.closest(".jsCheckoutSummaryBack")) {
				e.preventDefault();
				this.changeToFirstStep(e.target.closest(".jsCheckoutSummaryBack").location);
			}
		});

		document.body.addEventListener("input", (e) => {
			if (e.target.classList.contains("jsShippingMethodDescription")) {
				e.preventDefault();
				this.handleChangeShippingMethodDescription(e);
			} else if (e.target.closest(".jsShippingMethodDescription")) {
				e.preventDefault();
				this.handleChangeShippingMethodDescription(e);
			}
		});
	}

	handleChangeShippingMethodDescription(event) {
		const jsShippingMethodDescriptions = [...document.querySelectorAll(".jsShippingMethodDescription")];

		jsShippingMethodDescriptions.forEach((shippingMethodDescription) => {
			shippingMethodDescription.value = event.target.value;
		});

		this.shippingMethodDescription = event.target.value;
	}

	checkAllTerms(event) {
		if (event.target.checked) {
			this.jsTerms.forEach((term) => {
				term.checked = true;
				term.dispatchEvent(new Event("change", { bubbles: true }));
			});
		} else if (!event.target.checked) {
			this.jsTerms.forEach((term) => {
				term.checked = false;
				term.dispatchEvent(new Event("change", { bubbles: true }));
			});
		}
	}

	checkTerm(event) {
		const checkboxChecked = [];

		this.jsTerms.forEach((term) => {
			if (term.checked) {
				checkboxChecked.push(term);
			}
		});

		this.jsCheckAll.checked = checkboxChecked.length === this.jsTerms.length;
	}

	validateCheckout(event) {
		let value = "";
		this.jsBillingPersonType.forEach((input) => {
			if (input.checked) {
				value = input.value;
			}
		});

		if (!value) return;
		if (value === "company") {
			this.jsCheckoutTitle.innerHTML = this.jsCheckoutTitle.dataset.company;
		} else if (value === "person") {
			this.jsCheckoutTitle.innerHTML = this.jsCheckoutTitle.dataset.basic;
		}
	}

	verifyNextStep(event) {
		event.preventDefault();

		this.blockForAjax(this.jsCheckoutForm);
		const myFormData = new FormData(this.jsCheckoutForm);
		myFormData.append("security", window.global.security);

		const jsWoocommerceNotice = document.querySelector(".woocommerce-NoticeGroup");

		if (jsWoocommerceNotice) {
			jsWoocommerceNotice.remove();
		}

		fetch(window.global.ajax_url + "?action=checkoutNextStep", {
			method: "POST",
			mode: "cors",
			cache: "no-cache",
			credentials: "same-origin",
			redirect: "follow",
			referrerPolicy: "no-referrer",
			body: myFormData,
		})
			.then((resp) => resp.json())
			.then((res) => {
				this.unblockForAjax(this.jsCheckoutForm);
				if (res.success) {
					this.changeToSecondStep(res.data.content, res.data.buttons);
				} else {
					this.addNotices(res.data.notices);
					this.refreshFields();
				}

				window.scrollTo({
					top: 0,
					behavior: "smooth",
				});
			});
	}

	addNotices(notices) {
		const div = document.createElement("div");

		div.classList.add("woocommerce-NoticeGroup", "woocommerce-NoticeGroup-checkout");

		div.innerHTML = notices;

		this.jsCheckoutForm.prepend(div);
	}

	changeToFirstStep(location_string) {
		this.jsCheckoutForm.classList.add("checkout-main__form--first");
		this.jsCheckoutForm.classList.remove("checkout-main__form--second");

		this.jsCheckoutFirstPart.classList.remove("checkout-main__first-part--hidden");

		this.jsCheckoutSecondPart.classList.add("checkout-main__second-part--hidden");

		setTimeout(() => {
			location.hash = "#" + location_string;
		}, 500);
	}

	changeToSecondStep(content, buttons) {
		this.jsCheckoutForm.classList.remove("checkout-main__form--first");
		this.jsCheckoutForm.classList.add("checkout-main__form--second");
		this.jsCheckoutFirstPart.classList.add("checkout-main__first-part--hidden");

		this.jsCheckoutSecondPart.classList.remove("checkout-main__second-part--hidden");

		document.querySelector(".header-checkout__steps li:last-child").classList.add("is-active");

		this.jsCheckoutSecondPartContent.innerHTML = content;
		this.jsCheckoutSecondCustomOrderReviewButtons.innerHTML = buttons;
	}

	blockForAjax(element) {
		if (!element) return;

		const myBlock = new AjaxBlocking();
		myBlock.blockOnAjax(element);
	}

	unblockForAjax(element) {
		if (!element) return;

		const myBlock = new AjaxBlocking();
		myBlock.unblockOnAjax(element);
	}

	refreshFields() {
		this.fields.forEach((field) => {
			field.dispatchEvent(new Event("change", { bubbles: true }));
		});
		this.jsTerms.forEach((term) => {
			term.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}
}
